import { graphql } from 'relay-runtime';

export const gqlScheduleListingImagePadding = graphql`
  mutation scheduleListingImagePaddingMutation($listingId: String!) {
    invsysScheduleListingImagePadding(listingId: $listingId) {
      success
    }
  }
`;
